import logo from "assets/icons/logo.svg";
import { Link } from "react-router-dom";
import styled from "styled-components";

const Wrapper = styled(Link)`
  width: max-content;
  display: flex;

  img {
    height: 3.8rem;
  }
`;
const BetaStyle = styled.a`
  display: flex;

  img {
    height: 3.8rem;
  }
  
  span {
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    width: 4.8rem;
    height: 2.4rem;
    border-radius: 0.8rem;
    background-color: var(--secondary);
  }
`;

export const BetaLogo = () => (
  <BetaStyle className="logo" href="/beta/home">
    <img src={logo} alt="logo" /> <span>Beta</span>
  </BetaStyle>
);

export default function Logo() {
  return (
    <Wrapper className="logo" to="/home">
      <img src={logo} alt="PostPaddy" />
    </Wrapper>
  );
}
